import React, { useState } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';

import IfrsScheduleTable, { IfrsScheduleTableProps } from './IfrsScheduleTable';

export type IfrsScheduleModalProps = Pick<ModalProps, 'onCancel' | 'visible'> &
  IfrsScheduleTableProps & {
    controller?: React.ReactElement;
  };

const IfrsScheduleModal = ({
  financialSchedule = [],
  controller,
  onCancel: onCancelProp,
  visible: visibleProp,
  ...otherProps
}: IfrsScheduleModalProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      {controller &&
        React.cloneElement(controller, { onClick: () => setVisible(true) })}

      <Modal
        title="IFRS Schedule"
        footer={null}
        width={1200}
        style={{ top: '20px', height: '400px' }}
        visible={controller ? visible : visibleProp}
        onCancel={controller ? () => setVisible(false) : onCancelProp}
        {...otherProps}
      >
        <IfrsScheduleTable financialSchedule={financialSchedule} />
      </Modal>
    </>
  );
};

export default IfrsScheduleModal;
